import { Flex, Icon, Text } from '@chakra-ui/react'
import type { FC } from 'react'
import { MdArrowForwardIos } from 'react-icons/md'

type Props = {
  keyTopic: string | undefined | null
  subKeyTopic: string | undefined | null
}

export const KeyTopicTitle: FC<Props> = ({ keyTopic, subKeyTopic }) => {
  const hasKey = Boolean(keyTopic)
  const hasSub = Boolean(subKeyTopic)
  const titleText =
    hasKey && hasSub
      ? `${keyTopic} › ${subKeyTopic}`
      : (keyTopic ?? subKeyTopic ?? '')

  return (
    <Flex flex="2 1 0" minW="0" alignItems="baseline" overflow="hidden">
      <Text
        fontWeight={500}
        isTruncated
        whiteSpace="nowrap"
        minW="0"
        title={titleText}
        maxW="100%"
        display="block"
      >
        {hasKey ? keyTopic : subKeyTopic}
        {hasKey && hasSub && (
          <>
            <Icon boxSize="10px" as={MdArrowForwardIos} mx="1" />
            {subKeyTopic}
          </>
        )}
      </Text>
    </Flex>
  )
}
